import apiClient from '@/services/rest-api-vsms/apiClient'

const baseEndpoint = '/route'

export const get = async (queryParam) => {
  const params = new URLSearchParams()
  params.append('limit', queryParam.limit)
  params.append('page', queryParam.page)

  if (queryParam?.sorts?.length > 0) {
    params.append('sorts', queryParam.sorts)
  }

  if (queryParam?.search) {
    params.append('search', queryParam.search)
  }

  if (queryParam?.filters) {
    if (!Array.isArray(queryParam.filters)) {
      params.append('filters', queryParam.filters)
    } else {
      for (const filter of queryParam.filters) {
        params.append('filters', filter)
      }
    }
  }

  const response = await apiClient({
    method: 'GET',
    url: baseEndpoint,
    params: params,
  })

  return response?.data
}

export const getSearchByName = async (queryParam) => {
  const params = {
    limit: queryParam.limit,
    page: queryParam.page,
    sorts: queryParam?.sorts?.length > 0 ? queryParam.sorts : undefined,
    search: queryParam?.search ? queryParam?.search : undefined,
    filters: queryParam?.filters ? queryParam?.filters : undefined,
  }

  const response = await apiClient({
    method: 'GET',
    url: baseEndpoint,
    params: params,
  })

  return response?.data
}

export const show = async (id, params) => {
  const axiosConfig = {
    method: 'GET',
    url: `${baseEndpoint}/${id}`,
  }
  if (params) axiosConfig.params = params

  const response = await apiClient(axiosConfig)

  return response?.data
}

export const showDirection = async (id, params) => {
  const axiosConfig = {
    method: 'GET',
    url: `${baseEndpoint}/${id}/geometry`,
  }
  if (params) axiosConfig.params = params

  const response = await apiClient(axiosConfig)

  return response?.data
}

export const store = async (data) => {
  const response = await apiClient({
    method: 'POST',
    url: baseEndpoint,
    data,
  })

  return response?.data
}

export const update = async (id, data) => {
  const response = await apiClient({
    method: 'PATCH',
    url: `${baseEndpoint}/${id}`,
    data,
  })

  return response?.data
}

export const updateStatus = async (data) => {
  const response = await apiClient({
    method: 'POST',
    url: `${baseEndpoint}/change-status`,
    data,
  })

  return response?.data
}

export const generateRoute = async (longlat) => {
  const params = {
    search: longlat,
  }

  const response = await apiClient({
    method: 'GET',
    url: '/route_osrm',
    params: params,
  })

  return response?.data
}

export const deleteMany = async (data) => {
  data.ids = data.ids.map((id) => parseInt(id, 10))
  const response = await apiClient({
    method: 'POST',
    url: `${baseEndpoint}/delete`,
    data,
  })

  return response?.data
}

export const getVehicle = async (queryParam) => {
  const params = queryParam

  const response = await apiClient({
    method: 'GET',
    url: `${baseEndpoint}/vehicle/available-by-route`,
    params: params,
  })

  return response?.data
}

export const generateRoutePost = async (data) => {
  const response = await apiClient({
    method: 'POST',
    url: '/route_osrm/get',
    data: data,
  })

  return response?.data
}
